import { Action } from '@ngrx/store';
import * as industriesTypes from './industries.types'
import { Industry } from './industries.interface';

export class FetchIndustriesRequest implements Action {
    readonly type = industriesTypes.FETCH_INDUSTRIES_REQUEST;
    constructor(public payload: any = {}) { }
}

export class FetchIndustriesSuccess implements Action {
    readonly type = industriesTypes.FETCH_INDUSTRIES_SUCCESS;
    constructor(public payload: Industry[], public total: number) { }
}

export class FetchIndustriesFailure implements Action {
    readonly type = industriesTypes.FETCH_INDUSTRIES_FAILURE;
    constructor(public payload: any) { }
}

export class FetchIndustryRequest implements Action {
    readonly type = industriesTypes.FETCH_INDUSTRY_REQUEST;
    constructor(public id: number) { }
}

export class FetchIndustrySuccess implements Action {
    readonly type = industriesTypes.FETCH_INDUSTRY_SUCCESS;
    constructor(public payload: Industry) { }
}

export class FetchIndustryFailure implements Action {
    readonly type = industriesTypes.FETCH_INDUSTRY_FAILURE;
    constructor(public payload: any) { }
}

export class DeleteIndustryRequest implements Action {
    readonly type = industriesTypes.DELETE_INDUSTRY_REQUEST;
    constructor(public id: number) { }
}

export class DeleteIndustrySuccess implements Action {
    readonly type = industriesTypes.DELETE_INDUSTRY_SUCCESS;
    constructor() { }
}

export class DeleteIndustryFailure implements Action {
    readonly type = industriesTypes.DELETE_INDUSTRY_FAILURE;
    constructor(public payload: any) { }
}

export class CreateIndustryRequest implements Action {
    readonly type = industriesTypes.CREATE_INDUSTRY_REQUEST;
    constructor(public payload) { }
}

export class CreateIndustrySuccess implements Action {
    readonly type = industriesTypes.CREATE_INDUSTRY_SUCCESS;
    constructor() { }
}


export class CreateIndustryFailure implements Action {
    readonly type = industriesTypes.CREATE_INDUSTRY_FAILURE;
    constructor(public payload: any) { }
}


export class UpdateIndustryRequest implements Action {
    readonly type = industriesTypes.UPDATE_INDUSTRY_REQUEST;
    constructor(public id: number, public payload) { }
}

export class UpdateIndustrySuccess implements Action {
    readonly type = industriesTypes.UPDATE_INDUSTRY_SUCCESS;
    constructor() { }
}


export class UpdateIndustryFailure implements Action {
    readonly type = industriesTypes.UPDATE_INDUSTRY_FAILURE;
    constructor(public payload: any) { }
}

// Common

export class UpdateField implements Action {
    readonly type = industriesTypes.UPDATE_FIELD;
    public constructor(public field: string, public value: any, public path: string) { }
}

export class SetDefaultData implements Action {
    readonly type = industriesTypes.SET_DEFAULT_DATA;
    public constructor(public path: string) { }
}


export type Actions = UpdateIndustryRequest | UpdateIndustrySuccess | UpdateIndustryFailure |
    FetchIndustriesSuccess | FetchIndustriesFailure | FetchIndustriesRequest |
    FetchIndustrySuccess | FetchIndustryFailure | FetchIndustryRequest |
    CreateIndustryRequest | CreateIndustrySuccess | CreateIndustryFailure |
    DeleteIndustryRequest | DeleteIndustrySuccess | DeleteIndustryFailure |
    SetDefaultData | UpdateField
